import { AutoCalculate } from "global/Reducer/dataSlice";
import {
    IFlexibleFieldSet as FAM_IFlexibleFieldSet,
    IGroupConfigurationConfig as FAM_IGroupConfigurationConfig,
    IGroupConfigurationData as FAM_IGroupConfigurationData
} from "model/FlexibleAttributeModel";
import { BaseJsonTransformer, ITransformContext } from "./IJsonTransformer";

/**
 * Transformers:

 */
export class AutoCalculateTransformer extends BaseJsonTransformer {
    config: FAM_IGroupConfigurationConfig;

    constructor(config: FAM_IGroupConfigurationConfig) {
        super();
        this.config = config;
    }

    async before(json: FAM_IGroupConfigurationData): Promise<void> {

        const autoCalculateResult = AutoCalculate({ config: this.config, json: json });
    }

    async transformAttributeSet(attributeSet: FAM_IFlexibleFieldSet, context: ITransformContext): Promise<boolean | void> {

    }

    async after(json: FAM_IGroupConfigurationData): Promise<void> {
    }
}
